<template>
  <div>
    <div class="filter-inline-panel cle">
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" v-if="hasBtn('add')" @click="add('')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="id" align="center" label="ID"></el-table-column>
      <el-table-column :prop="lang=='cn'?'title_cn':'title'" align="center" :label="$t('mail.title')"></el-table-column>
      <el-table-column prop="total" align="center" :label="$t('index.operation')">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button type="info" size="mini" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination" v-if="pages_is">
      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
    <el-dialog :title="$t('index.dialog_title')" width="1200px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('mail.title')" prop="title_cn">
              <el-input v-model="editForm.title_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('mail.title')" prop="title">
              <el-input v-model="editForm.title" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('news_index.content')" prop="content_cn">
              <editor-bar v-model="editForm.content_cn"></editor-bar>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('news_index.content')" prop="content">
              <editor-bar v-model="editForm.content"></editor-bar>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import EditorBar from '../../components/wangEnduit.vue'
export default {
	components: {
		// EditorBar
	},
	computed: {
		editFormRules(){
			return{
				title_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('mail.title'),
					trigger: 'blur'
				}],
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('mail.title'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			editFormVisible: false,
			editForm: {},
			list: [],
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			pages_is:false,
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "highlightTmpList";
			this_.$post(url, {}).then((res) => {
				if (res.sum==undefined) {
					this_.list = res;
				}else{
					this_.list = res.list;
					this_.pages.count = res.sum;
					this_.pages_is=true;
				}
			})
		},
		add(data) {
			var this_ = this;
			if (data) {
				this_.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this_.editForm = {
					title: '',
					title_cn: '',
					content: '',
					content_cn: '',
					is_default: 0,
				}
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title: this_.editForm.title,
						title_cn: this_.editForm.title_cn,
						content_cn: this_.editForm.content_cn,
						content: this_.editForm.content,
						is_default: this_.editForm.is_default,
					}
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
					}
					var url = "highlightTmpAction";
					var tishi = this_.$t('index.add_success');
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		del(data) {
			var this_ = this;
			var url = "highlightTmpDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/mail/content.vue